import variables from './variables'
import blobImgMiddleSchool from 'experienceComponents/LandingBanner/assets/landingBannerBlobsELEM.svg'
import subBlobImgMiddleSchool from 'experienceComponents/SubLandingBanner/assets/subLandingBannerBlobsELEM.svg'
import backgroundImage from 'experienceComponents/UnitOverview/assets/img_unit_overview_blobs_elem.svg'

export default {
  meta: { themeName: 'elementary' },

  globalNav: {
    background: variables.colors.elemDigital2,
    iconHoverBackground: variables.colors.opacity_20,
  },
  colors: {
    themeAccent: variables.colors.elemDigital1,
    themeHighlight: variables.colors.elemDigital1,
    themePrimary: variables.colors.elemDigital2,
    themeSecondary: variables.colors.elemDigital3,
    themeDark: variables.colors.elemDigital3,
    themeTextLink: variables.colors.elemDigital3,
    classCardHover: variables.colors.elemDigital6,
    tierLabel: variables.colors.lightCyan,
    accordion: {
      headerTextColor: variables?.colors?.elemDigital3,
      icon: variables?.colors?.elemDigital1,
      iconHoverColor: variables?.colors?.elemDigital4,
      panelColor: variables?.colors?.paleGray,
    },
    backgrounds: {
      primary: variables.colors.elemDigital3,
    },
    borders: {
      primary: variables?.colors?.transparent,
      complete: variables?.colors?.transparent,
    },
    buttons: {
      dropdownIconHover: variables.colors.elemDigital4,
      iconBase: variables.colors.elemDigital1,
      iconHover: variables.colors.elemDigital4,
      opaqueDropdownHover: variables.colors.elemDigital4Opaque,
      productPreviewBackground: variables.colors.elemDigital1,
      previewBackground: variables.colors.elemDigital4,
      primaryBackground: variables.colors.elemDigital1,
      primaryBackgroundHover: variables.colors.elemDigital4,
      resumeBackground: variables.colors.elemDigital4,
      resumeBackgroundHover: variables.colors.elemDigital5,
      reviewBackground: variables.colors.elemDigital2,
      reviewBackgroundHover: variables.colors.elemDigital3,
      secondaryFont: variables.colors.white,
      startBackground: variables.colors.elemDigital1,
      startBackgroundHover: variables.colors.elemDigital2,
      tabActive: variables.colors.elemDigital4,
      tabDefault: variables.colors.darkGray,
      primary: {
        titleActive: variables.colors.white,
        bgActive: variables.colors.elemDigital1,
        bgHover: variables.colors.elemDigital2,
      },
      secondary: {
        titleActive: variables.colors.elemDigital4,
        titleHover: variables.colors.white,
        bgHover: variables.colors.elemDigital4,
      },
    },
    checkboxes: {
      backgroundCheckedColor: variables.colors.elemDigital2,
      backgroundCheckedColorHover: variables.colors.elemDigital4,
    },
    links: {
      primary: variables.colors.elemDigital2,
      primaryHover: variables.colors.elemDigital4,
    },
    headerBase: variables.colors.elemDigital3,
    headers: {
      primary: variables.colors.darkerDarkBlue,
    },
    heading: {
      level: {
        1: variables.colors.elemDigital3,
        2: variables.colors.elemDigital3,
        3: variables.colors.elemDigital3,
      },
    },
    selectSiteModal: {
      overlay: variables.colors.elemModalOverlay,
      buttonColor: variables.colors.white,
      backgroundColor: variables.colors.elemDigital4,
      trActive: variables.colors.elemDigital4,
      modalTitle: variables.colors.elemDigital3,
    },
    progressBar: {
      background: variables.colors.white,
      primary: variables.colors.lightPurple,
    },
    languageToggle: {
      // backgroundColor: variables.colors.paleGray,
      color: variables.colors.elemDigital3,
      backgroundColor: variables.colors.elemDigital1,
      hoverColor: variables.colors.elemDigital4,
    },
  },
  dashboard: {
    border: {
      width: '2px',
      color: variables.colors.paleGray,
    },
  },
  individualResource: {
    activityDetails: {
      h2: {
        size: '1.5rem',
        family: variables.font.sharpSlab.bold,
      },
      a: {
        color: variables.colors.elemDigital1,
        hover: {
          color: variables.colors.elemDigital4,
        },
      },
      button: {
        hover: {
          color: variables.colors.elemDigital4,
        },
      },
    },
    audienceTag: {
      backgroundColor: variables.colors.blueShade,
      color: variables.colors.darkGray,
    },
    h1: {
      fontFamily: variables.font.sharpSlab.bold,
    },
    h4: {
      fontFamily: variables.font.sharpSlab.bold,
      color: variables.colors.elemDigital3,
    },
    markCompleteButton: {
      color: variables.colors.elemDigital1,
      fill: variables.colors.elemDigital1,
    },
    metaData: {
      h4: {
        backgroundColor: variables.colors.mint,
      },
    },
    teachButton: {
      focusOutline: variables.colors.elemDigital1,
    },
  },
  preferencesSetup: {
    width: '246px',
    height: '185px',
    color: variables.colors.elemDigital3,
  },
  firstTimeClasses: {
    titleColor: variables.colors.elemDigital3,
    button: {
      backgroundColor: variables.colors.elemDigital1,
      color: variables.colors.elemDigital1,
      hoverColor: variables.colors.elemDigital4,
    },
  },
  // TODO: LEARN-9633, move backround images and colors to separate objects
  banners: {
    contentTypeDescriptionBackgroundColor: variables.colors.elemDigital2,
    headerTextColor: variables.colors.white,
    headerTextFont: 'Sharpslab-extrabold',
    headerTextSize: '42px',
    backgroundImage: backgroundImage,
    bannerTextColor: variables.colors.white,
    landingBackgroundColor: variables.colors.elemDigital3,
    landingBackgroundImage: blobImgMiddleSchool,
    sublandingBackgroundImage: subBlobImgMiddleSchool,
    alignment: 'center',
    textAlignment: 'center',
  },
  callouts: {
    iconBase: variables.colors.elemDigital1,
    iconHover: variables.colors.elemDigital1,
    hover: variables.colors.elemDigital3,
    headerTextColor: variables.colors.elemDigital2,
    headerTextFont: 'Sharpslab-extrabold',
    headerTextSize: '28px',
    bodyTextColor: variables.colors.black,
    backgroundColor: variables.colors.white,
    iconBorderRadius: '0.688rem 0.688rem 2.813rem 0.688rem',
    boxShadow: `0rem 0rem 0.625rem ${variables.colors.gray300}`,
  },
  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },
  resources: {
    backgroundColorTop: variables.colors.elemDigital2,
    backgroundColorBottom: variables.colors.backgroundNeutralGray,
  },
  primaryCTA: {
    training: {
      backgroundColor: variables.colors.primaryCTAOrange,
      titleColor: variables.colors.elemDigital3,
      buttonColor: variables.colors.elemDigital1,
      buttonHoverColor: variables.colors.elemDigital4,
    },
    create: {
      backgroundColor: variables.colors.blueShade,
      titleColor: variables.colors.darkBlue,
      buttonColor: variables.colors.blue,
    },
  },
  shutterList: {
    backgroundColor: variables.colors.paleGray,
  },
  tieredInterventionUnitCard: {
    styledContainer: {
      borderColor: {
        primary: variables.colors.mint,
        hover: variables.colors.elemDigital1,
      },
    },
    completionCircle: {
      borderColor: {
        primary: variables.colors.elemDigital1,
      },
    },
    header2: {
      color: variables.colors.elemDigital3,
    },
    tagText: {
      backgroundColor: variables.colors.lightCyan,
    },
  },
  tieredInterventionHeader: {
    headerWrapper: {
      backgroundColor: variables.colors.tieredInterventionGreen,
    },
  },
  tieredInterventionCallout: {
    tieredInterventionContainer: {
      backgroundColor: variables.colors.elemDigital3,
    },
  },
}
